// Small display helpers shared across pages — convert API enum strings into
// the casing the design expects.

const CABIN_LABEL: Record<string, string> = {
  economy: "Economy",
  premium_economy: "Premium economy",
  business: "Business",
  premium_business: "Premium business",
  first: "First",
  any: "Any cabin",
};

export function fmtCabin(value: string | null | undefined): string {
  if (!value) return "Economy";
  const v = String(value).toLowerCase();
  if (CABIN_LABEL[v]) return CABIN_LABEL[v];
  // Generic fallback: snake_case → Sentence case
  return v.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());
}

const PAX_LABEL: Record<string, string> = {
  adult: "Adult",
  child: "Child",
  infant: "Infant",
};

export function fmtPaxType(value: string | null | undefined): string {
  if (!value) return "";
  return PAX_LABEL[String(value).toLowerCase()] || String(value);
}
